import script from "./SecPillList.vue?vue&type=script&setup=true&lang=js"
export * from "./SecPillList.vue?vue&type=script&setup=true&lang=js"

import "./SecPillList.vue?vue&type=style&index=0&id=2dca79a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dca79a2"]])

export default __exports__